import { SET_TOPICS } from '../actions/action';
import { officialTopicsStorKey } from '../services/topics';
import { localStorageLoad } from '../services/localStorage';


/*
(15) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
0:
  category: "General view"
  topics: Array(8)
    0: {_id: "5e13b42c68cca74137489dec", name: "Region", descr: "Region"}
    1:
      _id: "5e13b42c68cca74137489ded"
      name: "Capital"
      descr: "Capital"
1:
  category: "Economic"
  (...)
*/


const topics = localStorageLoad(officialTopicsStorKey);

const initialState = {
  topics: topics && topics.topics ? topics.topics : []
}

export default (state = initialState, action) => {
  const { type, topics } = action;

  if (type === SET_TOPICS) {
    const newTopics = [...topics]
    return { ...state, topics: newTopics }
  }

  return state;
}